module.exports = __webpack_public_path__ + "img/pic_admin.360eef98.jpg";